/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ReceiptType {
    None = 0,
    Print = 1,
    Text = 2,
    Email = 4,
}
